// Our component's content.
export const content = [
  {
    id:1,
    title: 'Lothar Ruebelt',
    source: 'https://i.ebayimg.com/images/g/btEAAOSwSKBd3IdZ/s-l1600.jpg',
    price: '25$'
  },
  {
    id:2,
    title: 'Grain As A Weapon',
    source: 'https://i.ebayimg.com/images/g/WjAAAOSwZQRYedaF/s-l1600.jpg',
    price: '15.39$'
  },
  {
    id:3,
    title: 'Daring Tastemakers',
    source: 'https://i.ebayimg.com/images/g/J5QAAOSw2xRYPxY~/s-l1600.jpg',
    price: '15.99$'
  },
  {
    id:4,
    title: 'Magazine Ad en Campagne',
    source: 'https://i.ebayimg.com/images/g/zjUAAOSwJpda9xWG/s-l1600.jpg',
    price: '11.7$'
  }
];